<div class="update-container d-flex flex-column justify-content-center">
  @if(!isMobile){
  <div class="title-text">Update</div>
  <!-- <div class="member-text">Search by member id</div> -->
  }

  <form (ngSubmit)="onSubmit()">
    <div class="d-flex justify-content-between align-items-center form-gap mt-2">
      <input type="text" class="search-input dp-input-control" placeholder="Enter/paste member id" (keyup)="onSearch()"
        (keydown)="restrictSerialNoInput($event)" [formControl]="memberId" />
      @if(isMobile){
      <img class="inpImg" (click)="onSubmit()" src="/assets/master-search-assets/search-dark.png" alt="" />
      } @if(!isMobile){
      <button class="clr-btn dp-secondary-btn" type="reset" (click)="clear()">
        Clear
      </button>
      <button class="src-btn dp-primary-btn" type="submit">Search</button>
      }
    </div>
  </form>

  @if(!memberDetails) {
  <div class="img-bg">
    <img src="../../assets/images/update-search.png" class="img-width mb-4" />
    <span class="update-search-text">Search member to update</span>
  </div>
  } @else {
  <div class="update-card-container d-flex flex-column mt-4 cursor-pointer" (click)="update()">
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">Status</span>
      <span class="update-value">{{ status }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">SL. no</span>
      <div class="serial-no">
        <span class="serial-no-text cursor-pointer">{{
          memberDetails.memberKey
          }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">Name</span>
      <span class="update-value">{{ memberDetails.fullName }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">Guardian</span>
      <span class="update-value">{{ memberDetails.guardianName }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">Address</span>
      <span class="update-value">{{ memberDetails.addressPermanent }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">Ritwik Name</span>
      <span class="update-value">{{ memberDetails.ritwikName || '-' }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <span class="update-key">Initiation Date</span>
      <span class="update-value">{{ memberDetails.memberShipDate || '-' }}</span>
    </div>
    <button class="dp-primary-btn updateButton">Update</button>
  </div>
  }
</div>